import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class CorporateAffiliationsReport extends Component {
  state = {
    rowTables: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const affiliations = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].corporateAffiliations[0].affiliation"
      );
      const orderedAffiliations = _.orderBy(
        affiliations,
        (aff) => _.get(aff, "filingDate[0].year[0]._", 0),
        "desc"
      );
      if (orderedAffiliations.length > 0) {
        _.forEach(orderedAffiliations, (record, index) => {
          rows.push(
            <Table.Row
              key={`aff_comp_name_row_${index}`}
              className={recCount % 2 === 1 ? "table-row-odd-child" : ""}
            >
              <Table.Cell width={3} className="text-bold">
                Company Name:
              </Table.Cell>
              <Table.Cell width={7}>
                {_.get(record, "companyName[0]._", "")}
              </Table.Cell>
              <Table.Cell width={3} className="text-bold">
                Status:
              </Table.Cell>
              <Table.Cell width={3}>
                {`${_.get(record, "forProfit[0]._", "")} ${_.get(
                  record,
                  "statusDescription[0]._",
                  ""
                )}`}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row
              key={`aff_comp_add_row_${index}`}
              className={recCount % 2 === 1 ? "table-row-odd-child" : ""}
            >
              <Table.Cell width={3} className="text-bold">
                Company Address:
              </Table.Cell>
              <Table.Cell width={7}>
                <Address
                  addressNode={_.get(record, "address[0]")}
                  {...this.props}
                  ignoreLine1
                />
              </Table.Cell>
              <Table.Cell width={3} className="text-bold">
                Corporation Number:
              </Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "corporationNumber[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row
              key={`aff_comp_filing_row_${index}`}
              className={recCount % 2 === 1 ? "table-row-odd-child" : ""}
            >
              <Table.Cell colSpan={2} width={10} />
              <Table.Cell width={3} className="text-bold">
                Filing Date:
              </Table.Cell>
              <Table.Cell width={3}>
                {`${_.get(record, "filingDate[0].month[0]._", "")}/${_.get(
                  record,
                  "filingDate[0].year[0]._",
                  ""
                )}`}
              </Table.Cell>
            </Table.Row>
          );
          recCount += 1;
        });
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Corporate Affiliations"}
        rows={this.state.rows}
      />
    );
  }
}

export default CorporateAffiliationsReport;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/CorporateAffiliationsReport.js